import {Collapse, MenuItem} from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import UpDownChevronIcon from "assets/icons/UpDownChevronIcon";
import {useEffect, useState} from "react";

export interface BasicCollapseProps {
    title: string;
    defaultValue?: number;
    items?: {
        title: string;
        value: number;
    }[];
    onChange?: (value: any) => void;
}

export default function BasicCollapse(props: BasicCollapseProps) {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState(props.title);
    const items = props.items || [];
    const onChange = props.onChange;
    useEffect(() => {
        if (props.defaultValue) {
            const defaultItem = items.find((x) => x.value === props.defaultValue);
            if (defaultItem) setTitle(defaultItem.title);
        }
    }, [props.defaultValue]);
    return (
        <div
            style={{
                width: "100%",
                backgroundColor: "#F1F5F9",
                borderRadius: 6,
                cursor: "pointer",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "6px 12px",
                    fontSize: 12,
                }}
                onClick={() => setOpen((x) => !x)}
            >
                <span>{open ? props.title : title}</span>
                <span>{open ? <ChevronIcon rotate="top"/> : <UpDownChevronIcon/>}</span>
            </div>
            <Collapse in={open}>
                {items.map((item,index) => {
                    return (
                        <MenuItem
                        key={index}
                            style={{padding: "6px 12px", borderRadius: 6, fontSize: 14}}
                            onClick={() => {
                                onChange && onChange(item.value);
                                setTitle(item.title);
                                setOpen(false);
                            }}
                        >
                            {item.title}
                        </MenuItem>
                    );
                })}
            </Collapse>
        </div>
    );
}
